import {API_DRIVER} from "../configs/axios";

export const DigitalContractService = {
    fetchBulkListCards: (integrationId) => {
        return API_DRIVER.get(`/api/contract/bulk-list/customer/${integrationId}`)
    },
    fetchPlanOptionsForSim: (iccId, integrationId) => {
        return API_DRIVER.get(`/api/contract/current-plan/${iccId}/customer/${integrationId}`)
    },

    fetchOfferForNewPlan: (newCommercialLabel, oldCommercialLabel, integrationId) => {
        return API_DRIVER.get(`/api/contract/plan-details/${newCommercialLabel}/current/${oldCommercialLabel}/customer/${integrationId}`)
    },
    fetchBulkDetailsContent: (integrationId, bulkId) => {
        return API_DRIVER.get(`/api/contract/bulk-details/customer/${integrationId}/bulk/${bulkId}`)
    },
    fetchBulkDetailsOffer: (bulkId, integrationId) => {
        return API_DRIVER.get(`/api/contract/bulk-plan/customer/${integrationId}/bulk/${bulkId}`)
    },
    fetchBulkDetailsAssociatedSims: (integrationId, groupKey, tipoPiano) => {
        return API_DRIVER.get(`/api/contract/bulk-list-associated-sims/customer/${integrationId}/bulk/${groupKey}/${tipoPiano}`)
    },
    fetchBulkDetailsNotAssociatedSims: (integrationId, groupKey, tipoPiano) => {
        return API_DRIVER.get(`/api/contract/bulk-list-not-associated-sims/customer/${integrationId}/${groupKey}/${tipoPiano}`)
    },
    deleteGroupMembers: (deleteGroupMemberDto) => {
        return API_DRIVER.post(`/api/contract/bulk-del-group-members`, deleteGroupMemberDto)
    },
    addGroupMembers: (addGroupMemberDto) => {
        return API_DRIVER.post(`/api/contract/bulk-add-group-members`, addGroupMemberDto)
    },
    fetchAddRemoveOptions: (iccId, integrationId) => {
        return API_DRIVER.get(`/api/contract/add-remove-options/${iccId}/customer/${integrationId}`)
    },
    fetchBulkListForSim: (integrationId, msisdn) => {
        return API_DRIVER.get(`/api/contract/bulks-associated-to-sim/customer/${integrationId}/msisdn/${msisdn}`)
    },
    fetchDateForSim: (groupKey, msisdn) => {
        return API_DRIVER.get(`/api/contract/get-sim-data-associazione/${groupKey}/${msisdn}`)
    },
    downloadCsvBulkAssociatedSims: (integrationId, groupKey, tipoPiano) => {
        return API_DRIVER.get(`/api/contract/bulk-list-associated-sims/download-csv`, {
            params: {
                integrationId,
                groupKey,
                tipoPiano
            },
            responseType: 'blob'
        })
    }
}
